var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneNumbersActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Phone_Numbers_Active"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phone_Numbers_Active",
    "data-name": "Phone Numbers_Active",
    clipPath: "url(#clip-Phone_Numbers_Active)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Phone_Numbers",
    "data-name": "Phone Numbers",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2167",
    "data-name": "Group 2167",
    transform: "translate(0 9.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4747",
    "data-name": "Path 4747",
    d: "M24.272,32.35a1.425,1.425,0,0,1-.463-.051c-.223-.051-.446-.069-.652-.1-.257-.034-.5-.069-.72-.12a22.013,22.013,0,0,1-8.148-4.58,21.524,21.524,0,0,1-5.9-7.256c-.5-1.132-1.081-2.779-.48-3.928a15.114,15.114,0,0,1,2.916-3A1.273,1.273,0,0,1,11.663,13a1.244,1.244,0,0,1,.926.395l3.294,3.362a1.294,1.294,0,0,1,0,1.818c-1.235,1.252-1.492,1.921-1.51,2.093a17.441,17.441,0,0,0,3.088,3.242,21.852,21.852,0,0,0,2.865,2.144.606.606,0,0,0,.292.069c.549,0,1.338-.669,2.093-1.75a1.291,1.291,0,0,1,1.818-.326l3.808,2.728a1.312,1.312,0,0,1,.309,1.818L27.668,30c-.189.274-1.63,2.35-3.431,2.35Z",
    transform: "translate(-6.964 -12.314)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4748",
    "data-name": "Path 4748",
    d: "M11.967,13.972a.654.654,0,0,1,.446.189l3.294,3.362a.6.6,0,0,1,0,.858c-.652.669-1.8,1.973-1.681,2.693.12.755,2.625,3.053,3.328,3.654a21.437,21.437,0,0,0,2.985,2.23,1.37,1.37,0,0,0,.618.154c1.081,0,2.144-1.3,2.659-2.059a.6.6,0,0,1,.5-.257.57.57,0,0,1,.36.12l3.808,2.728a.607.607,0,0,1,.137.858l-.995,1.407s-1.355,2.041-2.865,2.041a1.056,1.056,0,0,1-.326-.034c-.5-.1-.978-.137-1.338-.223-4.872-1.2-11.579-6.845-13.586-11.442-.377-.875-.978-2.436-.5-3.311a15.7,15.7,0,0,1,2.762-2.8.6.6,0,0,1,.395-.154m0-1.39h0a1.96,1.96,0,0,0-1.287.48c-2.5,2.127-2.951,2.933-3.088,3.208-.755,1.407-.1,3.259.446,4.529,2.179,4.992,9.246,10.927,14.53,12.231a6.332,6.332,0,0,0,.789.137c.206.034.412.051.6.1a3.791,3.791,0,0,0,.6.069,4.317,4.317,0,0,0,2.951-1.407,8.693,8.693,0,0,0,1.046-1.235l.978-1.39a2.01,2.01,0,0,0-.463-2.762l-3.808-2.728a2.013,2.013,0,0,0-1.167-.377,1.978,1.978,0,0,0-1.63.858,3.672,3.672,0,0,1-1.51,1.458,19.761,19.761,0,0,1-2.728-2.059,23.355,23.355,0,0,1-2.779-2.779,8.108,8.108,0,0,1,1.235-1.544,2.009,2.009,0,0,0,0-2.8l-3.294-3.362a2.028,2.028,0,0,0-1.424-.6h0Z",
    transform: "translate(-7.251 -12.6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2169",
    "data-name": "Group 2169",
    transform: "translate(10.959 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4749",
    "data-name": "Path 4749",
    d: "M22.735,26.344H22.7a9.492,9.492,0,0,1-9.04-9.5A9.644,9.644,0,0,1,23.181,7.32a9.521,9.521,0,0,1,5.4,17.36.69.69,0,0,1-.789-1.132A8.135,8.135,0,1,0,15.05,16.841a8.023,8.023,0,0,0,7.737,8.114.689.689,0,0,1,.652.72.681.681,0,0,1-.686.652Z",
    transform: "translate(-13.66 -7.32)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2168",
    "data-name": "Group 2168",
    transform: "translate(11.022 17.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4750",
    "data-name": "Path 4750",
    d: "M20.74,17.81s-.172.051-.24.069",
    transform: "translate(-19.789 -17.115)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4751",
    "data-name": "Path 4751",
    d: "M20.779,18.855a.7.7,0,0,1-.669-.515.671.671,0,0,1,.5-.841,1.11,1.11,0,0,0,.223-.069.7.7,0,0,1,.377,1.338c-.086.017-.172.051-.274.069-.051,0-.12.017-.172.017Z",
    transform: "translate(-20.085 -17.405)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2170",
    "data-name": "Group 2170",
    transform: "translate(16.303 5.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4752",
    "data-name": "Path 4752",
    d: "M18.211,18.386h-.12a.681.681,0,0,1-.566-.789l1.081-6.416a.687.687,0,0,1,1.355.223L18.88,17.819a.685.685,0,0,1-.686.583Z",
    transform: "translate(-16.238 -10.604)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4753",
    "data-name": "Path 4753",
    d: "M20.161,18.386h-.12a.681.681,0,0,1-.566-.789l1.081-6.416a.687.687,0,0,1,1.355.223L20.83,17.819a.685.685,0,0,1-.686.583Z",
    transform: "translate(-14.843 -10.604)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4754",
    "data-name": "Path 4754",
    d: "M24.2,12.862H17.786a.686.686,0,1,1,0-1.372H24.2a.686.686,0,1,1,0,1.372Z",
    transform: "translate(-16.534 -9.969)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4755",
    "data-name": "Path 4755",
    d: "M23.872,14.812H17.456a.686.686,0,0,1,0-1.372h6.416a.686.686,0,0,1,0,1.372Z",
    transform: "translate(-16.77 -8.574)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneNumbersActive);
export default __webpack_public_path__ + "static/media/Phone_Numbers_Active.ffe07b16ba503a6d5fb5cbdaa18ba1fd.svg";
export { ForwardRef as ReactComponent };